"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchParcels = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var getSinceActionAtTimestamp = function getSinceActionAtTimestamp() {
  var daysToQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 90;
  var prior = new Date(Date.now() - daysToQuery * 24 * 60 * 60 * 1000);
  return prior.valueOf();
};

var _cachedGet;

var fetchParcels = function fetchParcels() {
  if (_cachedGet) {
    return _cachedGet;
  }

  _cachedGet = _apiClient.default.get('hubs/v2/parcels', {
    query: {
      sinceActionAt: getSinceActionAtTimestamp()
    }
  });
  return _cachedGet;
};

exports.fetchParcels = fetchParcels;